import { useSelector } from 'react-redux';
import EmailIcon from '@mui/icons-material/Email';
import LoginIcon from '@mui/icons-material/Login';
import mbiLogo from '../../assets/MBI-Logo2.png';
import IconButton from '../IconButton';
import AccountDetails from './AccountDetails';
import { isUserSignedIn } from '../../reducers/currentUser';

const useStyles = ({ height }) => ({
  header: {
    width: '100vw',
    height: `${height}px`,
    background: '#fff',
    display: 'flex',
    justifyContent: 'space-between',
  },
  headerLeft: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  headerRight: {
    display: 'flex',
    alignItems: 'center',
    padding: 10,
  },
  logo: {
    maxHeight: 50,
    margin: 5,
    padding: '0 0 0 20px',
  },
});

const buttonConfigs = {
  login: <IconButton
    Icon={LoginIcon}
    text="Login"
    href="/login"
    size={36}
  />,
  logout: <AccountDetails />,
};

const MobileMapHeader = ({ height }) => {
  const isSignedIn = useSelector(isUserSignedIn);
  const startEmail = () => {
    window.open('mailto:mapfeedback@masstech.org');
  };
  const styles = useStyles({ height });
  return (
    <header style={styles.header}>
      <div id="header-left" style={styles.headerLeft}>
        <img src={mbiLogo} alt="MBI Logo" style={styles.logo} />
      </div>
      <div id="header-right" style={styles.headerRight}>
        <IconButton text="Contact Us" Icon={EmailIcon} onClick={startEmail} />
        {isSignedIn ? buttonConfigs.logout : buttonConfigs.login}
      </div>
    </header>
  );
};

export default MobileMapHeader;
